export default __webpack_public_path__ + "static/media/gallery-wip-crystal-chamber_02.122be27d.jpg";